/**
 * Calculates the average rating from an array of reviews.
 * @param reviews An array of review objects containing a `rating` property.
 * @returns The average rating rounded to two decimal places.
 */
export const calculateAverageRating = (reviews: { rating: number }[]): number => {
  // Check if the reviews array is empty - return 0 if there are no reviews
  if (reviews.length === 0) {
    return 0;
  }

  // Calculate the total sum of ratings
  const totalRating = reviews.reduce((acc, review) => acc + review.rating, 0);

  // Calculate the average rating
  const averageRating = totalRating / reviews.length;

  // Return the average rating rounded to two decimal places
  return Math.round(averageRating * 100) / 100;
}